import { Stack } from '@mui/material';

import { toSentenceCase } from 'common/utils/utilFunctions';

import styles from './CreateRole.module.scss';

interface IRoleActionPermission {
	label: string;
	selectAll: any;
	clearAll: any;
	displayActions: boolean;
}
const RoleActionPermission = (props: IRoleActionPermission) => {
	const { label, displayActions, selectAll, clearAll } = props;

	return (
		<Stack
			direction="row"
			justifyContent="space-between"
			className={styles['roles-access-permissions']}
		>
			<Stack className={styles['roles-access-permissions-summary-label']}>
				{label}
			</Stack>
			{displayActions && (
				<Stack direction="row" sx={{ alignItems: 'center' }} spacing={1}>
					<Stack
						data-testid="selectall"
						className={styles['roles-access-permissions-summary-select']}
						onClick={selectAll()}
					>
						{toSentenceCase('Select All')}
					</Stack>
					<Stack>|</Stack>
					<Stack
						data-testid="clearall"
						className={styles['roles-access-permissions-summary-clear']}
						onClick={clearAll()}
					>
						{toSentenceCase('Clear All')}
					</Stack>
				</Stack>
			)}
		</Stack>
	);
};

export default RoleActionPermission;
